import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Payroll } from '@app/models/payroll/payroll.model';
import { XeroIntegrationService } from '@app/modules/settings/services/xero-integration.service';
import { BadgeType } from '@humi-design-library/components/Badge/types';
import { TranslateService } from '@ngx-translate/core';
import { getYear, parse } from 'date-fns';
import { Subject } from 'rxjs';

@Component({
    templateUrl: './payroll-show.template.html',
})
export class PayrollShowView implements OnInit, OnDestroy {
    payroll: Payroll;
    xeroCompanyName?: string;
    xeroStatus: BadgeType = 'default';
    xeroStatusMessage = '';
    showXeroInProgressWarningModal = false;

    private _onDestroy$ = new Subject();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private translateService: TranslateService,
        private xeroIntegrationService: XeroIntegrationService
    ) {
        this.payroll = this.route.snapshot.data.models.get('payroll');
    }
    ngOnDestroy(): void {
        this._onDestroy$.next();
        this._onDestroy$.complete();
    }

    async ngOnInit(): Promise<void> {
        this.getXeroName();
        this.setXeroStatusAndMessage();
    }

    get shouldShowXeroCard(): boolean {
        return !!this.payroll.latestXeroIntegrationJob;
    }

    get payrollRegisterUrl(): string {
        return this.router.serializeUrl(
            this.router.createUrlTree(['/reporting/payroll/payroll-register'], {
                queryParams: {
                    payrollType: this.payroll?.recurring ? 'recurring' : 'off-cycle',
                    payPeriod: this.payroll?.recurring ? this.payroll?.periodNo : this.payroll?.chequeDate,
                    year: getYear(parse(this.payroll?.chequeDate)),
                },
                queryParamsHandling: 'merge',
            })
        );
    }

    get payrollType(): string {
        const type = this.payroll.recurring ? 'payroll.records.recurring' : 'payroll.records.offCycle';
        return this.translateService.instant(type);
    }

    get showQhsfRate(): boolean {
        return parseFloat(this.payroll.qhsfAmount) > 0;
    }

    private async getXeroName(): Promise<void> {
        const integration = await this.xeroIntegrationService.getXeroIntegrationDetails();

        if (integration) {
            this.xeroCompanyName = integration.xeroCompanyName;
        }
    }

    private setXeroStatusAndMessage(): void {
        if (this.payroll.latestXeroIntegrationJob.status === 'success') {
            this.xeroStatus = 'success';
            this.xeroStatusMessage = 'payroll.records.dataSent';
            return;
        }

        this.xeroStatus = 'danger';
        this.xeroStatusMessage = 'payroll.records.error';
    }
}
